import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { OnlineBtn } from '../styles/dialpadstyle'
import { Button } from 'modules/theme'

export class OfflineDialpad extends Component {
  render() {
    const { ButtonText, OnClickEvent, error } = this.props;
    return (
      <OnlineBtn>
        { error && <div className="col-md-12 text-danger text-center">{error}</div> }
        { !error &&
          <Button btnStyle="simple" hoverColor="white" size="small" onClick={OnClickEvent}>
            {ButtonText}
          </Button>
        }
      </OnlineBtn>
    )
  }
}


OfflineDialpad.contextTypes = {
  __: PropTypes.func
};

export default OfflineDialpad


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/OfflineDialpad.js